import { render, staticRenderFns } from "./icon-search.vue?vue&type=template&id=7253c68f&scoped=true&"
import script from "./icon-search.vue?vue&type=script&lang=js&"
export * from "./icon-search.vue?vue&type=script&lang=js&"
import style0 from "./icon-search.vue?vue&type=style&index=0&id=7253c68f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7253c68f",
  null
  
)

export default component.exports